import React from "react";
import { Check } from "lucide-react";
import { useApp } from "@/state/AppContext";
import { dateTime } from "@/lib/format";

export function StatusTimeline({ timeline = [], labelsKey, testId, labelOverrides }) {
  const { t, lang } = useApp();
  const labels = { ...t(labelsKey), ...(labelOverrides || {}) };
  return (
    <ol className="mt-3 space-y-2" data-testid={testId}>
      {timeline.map((step, index) => (
        <li key={`${step.status}-${index}`} className="flex items-start gap-3">
          <span
            className={`mt-0.5 grid h-5 w-5 shrink-0 place-items-center rounded-full ${
              index === timeline.length - 1
                ? "bg-[hsl(var(--primary))] text-primary-foreground"
                : "bg-muted text-muted-foreground"
            }`}
          >
            <Check size={11} />
          </span>
          <div>
            <p className="text-sm font-medium">{labels[step.status] || step.status}</p>
            <p className="text-xs text-muted-foreground">{dateTime(step.at, lang)}</p>
          </div>
        </li>
      ))}
    </ol>
  );
}
